import { Breadcrumb } from '@oliasoft-open-source/react-ui-library';
import { HierarchyLevelType } from 'common/interfaces/hierarchy-entities';
import { hierarchyLevelTypeName } from './hierarchy.utils';
import { HierarchyTreeItems, IHierarchyTreeItem } from './hierarchy.interfaces';

type HierarchyBreadcrumbProps = {
  hierarchy: HierarchyTreeItems;
  selectedItemId: string | null;
  topLevel: HierarchyLevelType;
  onClick: (value: IHierarchyTreeItem) => void;
};

export const HierarchyBreadcrumb = ({
  hierarchy,
  selectedItemId,
  topLevel,
  onClick,
}: HierarchyBreadcrumbProps) => {
  if (!selectedItemId) return;
  const item = hierarchy[selectedItemId];
  if (!item) return null;
  const items: IHierarchyTreeItem[] = [item];

  if (item.entityType !== topLevel) {
    let currentId = item.parentId || '';
    while (currentId) {
      const parent = hierarchy[currentId];
      if (!parent) break;
      items.unshift(parent);
      currentId = parent.parentId || '';
      if (parent.entityType === topLevel || parent.entityType === HierarchyLevelType.Archive) break;
    }
  }

  const links = items.map((item, index) => {
    const isLast = index === items.length - 1;
    return {
      label: item.name,
      title: hierarchyLevelTypeName[item.entityType],
      active: isLast,
      ...(!isLast && { onClick: () => onClick(item) }),
    };
  });

  return <Breadcrumb small links={links} />;
};
